import { useContext } from "react";

import { SelectAnswerContext } from "../contexts/selectAnswerContext";

function useShowingCorrectAnswer() {
  const { showingCorrectAnswer } = useContext(SelectAnswerContext);
  return showingCorrectAnswer;
}

export default useShowingCorrectAnswer;
